import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonHelper } from '@meplis/common';
import { SkeletonDirective } from '@meplis/directives';

@Component({
  selector: 'app-profile-avatar',
  imports: [CommonModule, SkeletonDirective],
  templateUrl: './profile-avatar.component.html',
  styleUrl: './profile-avatar.component.scss',
})
export class ProfileAvatarComponent implements OnChanges {
  @Input() profileId: string | number;
  @Input() profileAvatarUrl: string;
  @Input() size: 'large' | 'medium' | 'small' = 'medium';

  public isLoaded: boolean;
  public hasError: boolean;

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.profileId) {
      this.profileAvatarUrl = CommonHelper.getAvatarImage(this.profileId);
    }
  }

  onLoad(): void {
    setTimeout(() => {
      this.isLoaded = true;
      this.hasError = false;
    }, 500);
  }

  onError(): void {
    setTimeout(() => {
      this.isLoaded = false;
      this.hasError = true;
    }, 500);
  }
}
